export default "/img/GB.320bf84602b744afea7630f0ceab6218.png";